// src/hooks/useWidgetData.js
//
// Custom hook untuk fetch satu widget via widgetAPI.
//
// Contoh:
//   const { data, loading, error, reload } = useWidgetData('top10_username', { period: '24h' });
//
// Otomatis re-fetch jika `widget` atau `filter` berubah.
// `filter` dibandingkan secara JSON agar tidak infinite loop.

import { useState, useEffect, useCallback, useRef } from 'react';
import widgetAPI from '../api/widgetAPI';

export default function useWidgetData(widget, filter = {}) {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  // Serialize filter sekali agar bisa dibandingkan stabil
  const filterRef = useRef(null);
  const filterStr = JSON.stringify(filter);

  const load = useCallback(async () => {
    if (!widget) return;
    setLoading(true);
    setError(null);
    try {
      const result = await widgetAPI.fetch(widget, JSON.parse(filterRef.current || '{}'));
      setData(result);
    } catch (e) {
      setError(e?.response?.data?.error || e.message || 'Gagal memuat data');
    } finally {
      setLoading(false);
    }
  }, [widget]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    filterRef.current = filterStr;
    load();
  }, [widget, filterStr]); // eslint-disable-line react-hooks/exhaustive-deps

  return { data, loading, error, reload: load };
}